var i4_Ajax = {
	ajax_file: '',
	
	set_ajax_file: function(v) { this.ajax_file = v; return this; },

	factory: function() {
		var ajax = $.extend({}, i4_jq_Ajax_instance);
		ajax.initialize();
		ajax.set_ajax_file(this.ajax_file);
		return ajax;
	}
};

var i4_jq_Ajax_instance = { 
	id: '',
	ajax_file: '',
	parameter: '',
	option: {},
	
	initialize: function() {
		// default options
		this.id = '';
		this.$responseContainer = '';
		this.ajax_file = '';
		this.parameter = '';
		this.option = {
			on_success: function(){},
			on_complete: function(){}
		};
	},
	
	set_id: function(v) { this.id = v; return this; },
	set_response_container: function($element) { this.$responseContainer = $element; return this; },
	set_ajax_file: function(v) { this.ajax_file = v; return this; },
	set_parameter: function(v) { this.parameter = '&'+v; return this; },
	
	set_option: function(option) { 
		this.option = $.extend(this.option, option); 
		return this; 
	},
	
	run: function() {
		// console.log('run()', this.ajax_file);
		// console.log('run() parameter', this.parameter);
		
		if (this.ajax_file !== '') {
			// console.log('ajax-url', this.ajax_file+this.parameter);
			
			$.ajax({
				url: this.ajax_file+this.parameter,
				success: (function(responseText) {
					this.option.on_success(responseText);
					
				}).bind(this),
				complete: (function(response) {
					
					if (this.id !== '' && $('#'+this.id).length) {
						$('#'+this.id).html(response.responseText);
					} else if (this.$responseContainer !== '' && this.$responseContainer.length) {
						this.$responseContainer.html(response.responseText);
					}
					
					this.option.on_complete(response.responseText, response.responseJSON);		
					i4_Decorator_loader.load();

				}).bind(this)
			});
			
			
		} else {
			throw('i4_ajax.js - ajax_file not set');
		}
	
	}
};